import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
// HELPERS
import { URL_GENERAL_DASHBOARD } from "Helpers/Paths";

const GuestRoute = (props) => {
	const { isLoggedIn, children } = props;

	return <Fragment>{isLoggedIn ? <Navigate to={URL_GENERAL_DASHBOARD} replace /> : children}</Fragment>;
};

const mapReduxStateToProps = (state) => ({ isLoggedIn: state.Auth.isLoggedIn });

export default connect(mapReduxStateToProps, null)(GuestRoute);
